import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export default function InzetPartijen({ magBeheer }) {
  const [open, setOpen] = useState(false);
  const [partijen, setPartijen] = useState([]);
  const [naam, setNaam] = useState('');
  const [email, setEmail] = useState('');
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState(null);

  const laad = useCallback(() => {
    api.get('/inzetmiddelen/partijen').then(r => setPartijen(r.data.partijen || [])).catch(() => {});
  }, []);
  useEffect(() => { laad(); }, [laad]);

  const toevoegen = () => {
    if (!naam.trim()) return;
    setBezig(true); setMelding(null);
    api.post('/inzetmiddelen/partijen', { naam: naam.trim(), email: email.trim() || null })
      .then(r => { setNaam(''); setEmail(''); setMelding({ ok: true, t: r.data.message || 'Partij toegevoegd' }); laad(); })
      .catch(e => setMelding({ ok: false, t: e.response?.data?.message || 'Toevoegen mislukt' }))
      .finally(() => setBezig(false));
  };
  const toggle = (p) => {
    api.put('/inzetmiddelen/partijen/' + p.id, { actief: !p.actief }).then(laad).catch(() => alert('Wijzigen mislukt'));
  };
  const mail = (p) => {
    if (!p.email) { alert('Geen e-mailadres bij deze partij'); return; }
    api.post('/inzetmiddelen/partijen/' + p.id + '/mail').then(r => setMelding({ ok: true, t: r.data.message || 'Link gemaild' })).catch(e => setMelding({ ok: false, t: e.response?.data?.message || 'Mailen mislukt' }));
  };
  const kopieer = (p) => {
    navigator.clipboard.writeText(p.link).then(() => setMelding({ ok: true, t: 'Link gekopieerd: ' + p.naam })).catch(() => window.prompt('Kopieer de link:', p.link));
  };
  const emailWijzig = (p) => {
    const nieuw = window.prompt('E-mailadres voor ' + p.naam + ':', p.email || '');
    if (nieuw === null) return;
    api.put('/inzetmiddelen/partijen/' + p.id, { email: nieuw.trim() || null }).then(laad).catch(() => alert('Wijzigen mislukt'));
  };

  const actief = partijen.filter(p => p.actief).length;
  return (
    <>
      <button className="inzet-btn-light" onClick={() => setOpen(true)} style={{ marginLeft: 8 }}>
        🔗 Reserveerlinks ({actief})
      </button>
      {open && (
        <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 12px', overflowY: 'auto' }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 720, padding: 20, boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h2 style={{ margin: 0, fontSize: 18 }}>🔗 Reserveerlinks per partij</h2>
              <button className="inzet-btn-light" onClick={() => setOpen(false)}>Sluiten</button>
            </div>
            <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 12px' }}>
              Elke partij (KWS, GVB-afdeling, aannemer) krijgt een eigen vaste link om inzetmiddelen te reserveren. Uitzetten blokkeert de link direct.
            </p>

            {melding && <div style={{ marginBottom: 10, padding: '8px 12px', borderRadius: 8, fontSize: 13, background: melding.ok ? '#d1fae5' : '#fee2e2', color: melding.ok ? '#065f46' : '#991b1b' }}>{melding.t}</div>}

            {magBeheer && (
              <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
                <input value={naam} onChange={e => setNaam(e.target.value)} placeholder="Naam partij (bijv. KWS)" style={{ flex: 1, minWidth: 160, padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8 }} />
                <input value={email} onChange={e => setEmail(e.target.value)} placeholder="E-mail (link wordt gemaild)" style={{ flex: 1, minWidth: 200, padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8 }} />
                <button className="btn-primary" disabled={bezig || !naam.trim()} onClick={toevoegen}>+ Partij</button>
              </div>
            )}

            {partijen.length === 0 && <div style={{ color: '#6b7280', fontSize: 13 }}>Nog geen partijen.</div>}
            {partijen.map(p => (
              <div key={p.id} style={{ borderTop: '1px solid #f3f4f6', padding: '10px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', opacity: p.actief ? 1 : 0.55 }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{p.naam} {!p.actief && <span style={{ fontSize: 11, color: '#991b1b', border: '1px solid #fca5a5', borderRadius: 999, padding: '1px 8px', marginLeft: 6 }}>uit</span>}</div>
                  <div style={{ fontSize: 12, color: '#6b7280' }}>
                    <span style={{ cursor: 'pointer', textDecoration: 'underline dotted' }} onClick={() => magBeheer && emailWijzig(p)}>{p.email || 'geen e-mail'}</span>
                    {' · '}{p.aantal_aanvragen || 0} aanvragen
                  </div>
                  <div style={{ fontSize: 11, color: '#9ca3af', fontFamily: 'monospace', wordBreak: 'break-all' }}>{p.link}</div>
                </div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  <button className="inzet-btn-light" onClick={() => kopieer(p)}>📋 Kopieer</button>
                  {magBeheer && <button className="inzet-btn-light" onClick={() => mail(p)}>📧 Mail link</button>}
                  {magBeheer && <button className="inzet-btn-light" style={{ color: p.actief ? '#dc2626' : '#059669' }} onClick={() => toggle(p)}>{p.actief ? 'Uitzetten' : 'Aanzetten'}</button>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
